import RefundPartialPaymentsForm from './RefundPartialPaymentsForm'
import PaidSalesOrderRefundForm from './PaidSalesOrderRefundForm'
import type { SalesOrder } from '@/lib/services/sales-orders/sales-orders.types'

interface RefundFormProps {
  order: SalesOrder
  /** The order's payment snapshot with its cart id, as the order page passes it; the collected-payments refund reads it. */
  cart?: { id?: number | null } | null
  onCompleted?: () => void
}

function RefundForm({ order, cart, onCompleted }: RefundFormProps) {
  // The server says how money goes back: while there is still something to collect, each payment returns what it
  // holds; otherwise the order's lines are credited.
  if (order.financial_state.refund_mode === 'tender_return' && cart?.id) {
    return <RefundPartialPaymentsForm cart={cart} order={order} onCompleted={onCompleted} />
  }

  return <PaidSalesOrderRefundForm key={order.id} order={order} onCompleted={onCompleted} />
}

export default RefundForm
